import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

function LanguageSelectButton() {
  const dispatch = useDispatch();
  const {
    languages,
    tab,
  } = useSelector(store => store.translations);

  function handleTabChange({ target }) {
    dispatch({ type: 'CHANGE_TRANSLATION_TAB', payload: target.id });
  }

  return (
    <div className="row">
      <div className="col">
        <div className="py-2 bg-darker d-flex justify-content-around align-items-center mb-3">
          <div className="w-100 text-center">
            {languages.map((language) => (
              <button
                type="button"
                id={language}
                color="clear"
                className={[
                  'btn no-click-children rounded-pill p-1 border-lg details-control me-3',
                  tab === language ? 'border-white active' : '',
                ].join(' ')}
                onClick={(e) => handleTabChange(e)}
              >
                <div
                  className={[
                    'rounded-pill d-flex bg-white text-body px-3 py-2',
                    'd-flex align-items-center justify-content-center',
                  ].join(' ')}
                >
                  <h6 className="m-0">{language}</h6>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LanguageSelectButton;
// causes hover buttons to have slightly whiter border
